/** @file Push button: the label comes in as a prop; `primary` and `danger` flags pick the look. */
import './tokens.css';
import './Button.css';
import { joinClass } from './logic/joinClass';

/** Props of Button. */
export interface ButtonProps {
  /** Already-translated text shown on the button. */
  label: string;
  onClick: () => void;
  /** Accent-filled call to action; wins over `danger` when both are set. */
  primary?: boolean;
  /** Red outline for destructive actions. */
  danger?: boolean;
  disabled?: boolean;
  /** Already-translated tooltip. */
  title?: string;
}

/** Push button; never submits a form. */
export function Button({ label, onClick, primary = false, danger = false, disabled = false, title }: ButtonProps) {
  const look = primary ? 'p2-button-primary' : danger && 'p2-button-danger';
  return (
    <button type="button" className={joinClass('p2-button', look)} disabled={disabled} title={title} onClick={onClick}>
      {label}
    </button>
  );
}
